import { useSelector } from 'react-redux'
import groupSlice from './groupSlice'

export const useGroups = () => {
  const reducerState = useSelector((state) => state)
  return reducerState
}

export const { getAllGroups, clearGroups } = groupSlice.actions

export default groupSlice.reducer
